// Dateiname für einen Supabase-Storage-Schlüssel (Ticket #480, 09.10.2026).
//
// Supabase Storage lehnt Schlüssel mit Umlauten und anderen Nicht-ASCII-Zeichen ab
// ("Invalid key"). Mehrere Stellen haben den Dateinamen roh in den Pfad geschrieben —
// "Kündigungsbestätigung.pdf" scheiterte im Mail-Editor mit "Upload fehlgeschlagen".
// Befund vor dem Fix: unter rund 850 gespeicherten Dateien in ALLEN Buckets stand keine
// einzige mit Umlaut im Namen; jeder solche Upload war gescheitert.
//
// Nur der SCHLÜSSEL wird bereinigt. Den Namen, den Nutzer und Mail-Empfänger sehen, führen
// die Aufrufer weiter im Original (graph-mail-send nimmt `name` vor dem Pfad).

const UMLAUTE: Record<string, string> = {
  ä: 'ae', ö: 'oe', ü: 'ue', Ä: 'Ae', Ö: 'Oe', Ü: 'Ue', ß: 'ss',
};

export function speicherName(name: string | null | undefined, ersatz = 'datei'): string {
  const roh = (name || '').trim();
  const umgeschrieben = roh
    .replace(/[äöüÄÖÜß]/g, (z) => UMLAUTE[z])
    // é → e usw.: Grundbuchstabe behalten, Akzent weg
    .normalize('NFKD').replace(/[̀-ͯ]/g, '')
    // Alles außer Buchstaben, Ziffern, Punkt, Bindestrich, Unterstrich → _
    .replace(/[^A-Za-z0-9._-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^[._]+|_+$/g, '');
  if (!umgeschrieben) return ersatz;
  // Lange Namen kürzen, Endung behalten
  if (umgeschrieben.length <= 120) return umgeschrieben;
  const punkt = umgeschrieben.lastIndexOf('.');
  const endung = punkt > 0 && umgeschrieben.length - punkt <= 10 ? umgeschrieben.slice(punkt) : '';
  return umgeschrieben.slice(0, 120 - endung.length) + endung;
}
